import { signOut } from 'next-auth/react';
import useMarket from 'stores/useMarket';

export function useSignOut() {
    return (path: string = '') => {
        signOut({
            redirect: true,
            callbackUrl: path,
        });
    };
}
